import React from 'react'; 
import {
    TouchableNativeFeedback, 
    TouchableOpacity,
    View,
    Platform,
} from 'react-native';

class ReactTouchableArea extends React.Component {
    constructor(props)
    {
        super(props);
    
        this.timeout = null;
    }
    
    handlePress = e => {
        const { onPress, onPressParams, debounceTime, onPressWithEvent } = this.props;
    
        if(this.timeout)
            clearTimeout(this.timeout);
        else if(onPressWithEvent)
            onPress(e, onPressParams);
        else
            onPress(onPressParams);
        
        this.timeout = setTimeout(() => {
            this.timeout = null;
        }, debounceTime);
    };
    
    render() {
        if(!this.props.onPress)
            return (<View {...this.props}>{this.props.children}</View>);
        
        let extraProps = {};
        
        if(Platform && Platform.OS == 'browser')
            extraProps.animateClick = (typeof this.props.animateClick == 'undefined' ? true : this.props.animateClick);

        if(Platform && Platform.OS === 'android')
            return( <TouchableNativeFeedback onPress={this.handlePress} {...extraProps}><View {...this.props}>{this.props.children}</View></TouchableNativeFeedback> );

        return( <TouchableOpacity {...this.props} {...extraProps} onPress={this.handlePress}>{this.props.children}</TouchableOpacity> );
    }
}

ReactTouchableArea.defaultProps = {
    debounceTime: 500,
    onPressWithEvent: true,
}

export default ReactTouchableArea;